import { Icon } from '@chakra-ui/react';
import {
  Md3DRotation,
  MdAddHomeWork,
  MdArchive,
  MdCalculate,
  MdDashboard,
  MdDirections,
  MdDirectionsOff,
  MdMap,
  MdDocumentScanner,
  MdEditDocument,
  MdEmojiPeople,
  MdHome,
  MdHouse,
  MdLock,
  MdLogin,
  MdMoney,
  MdNewspaper,
  MdOutlineContactEmergency,
  MdOutlineShoppingCart,
  MdPausePresentation,
  MdPriceCheck,
  MdRule,
  MdSettings,
  MdViewAgenda,
  MdWash,
  MdWork,
} from 'react-icons/md';

// Admin Imports
import DashboardsDefault from 'views/admin/dashboards/default';
//import DashboardsRTLDefault from 'views/admin/dashboards/rtl';
import Secciones from 'views/admin/dashboards/secciones';
import DashboardsSmartHome from 'views/admin/dashboards/smartHome';

// // NFT Imports
import NFTMarketplace from 'views/admin/nfts/marketplace';
import NFTPage from 'views/admin/nfts/page';
import NFTCollection from 'views/admin/nfts/collection';
import NFTProfile from 'views/admin/nfts/profile';

// Main Imports
import AccountBilling from 'views/admin/main/account/billing';
import AccountApplications from 'views/admin/main/account/application';
import AccountInvoice from 'views/admin/main/account/invoice';
import AccountSettings from 'views/admin/main/account/settings';
import AccountAllCourses from 'views/admin/main/account/courses';
import AccountCoursePage from 'views/admin/main/account/coursePage';

import UserNew from 'views/admin/main/users/newUser';
import UsersOverview from 'views/admin/main/users/overview';
import UsersReports from 'views/admin/main/users/reports';

import ProfileSettings from 'views/admin/main/profile/settings';
import ProfileOverview from 'views/admin/main/profile/overview';
import ProfileNewsfeed from 'views/admin/main/profile/newsfeed';

import ApplicationsKanban from 'views/admin/main/applications/kanban';
import ApplicationsDataTables from 'views/admin/main/applications/dataTables';
import ApplicationsCalendar from 'views/admin/main/applications/calendar';

import EcommerceNewProduct from 'views/admin/main/ecommerce/newProduct';
import EcommerceProductOverview from 'views/admin/main/ecommerce/overviewProduct';
import EcommerceProductSettings from 'views/admin/main/ecommerce/settingsProduct';
import EcommerceProductPage from 'views/admin/main/ecommerce/pageProduct';
import EcommerceOrderList from 'views/admin/main/ecommerce/orderList';
import ProductosLista from 'views/admin/main/ecommerce/productoslista';
import EcommerceOrderDetails from 'views/admin/main/ecommerce/orderDetails';
import EcommerceReferrals from 'views/admin/main/ecommerce/referrals';

// Others
import OthersNotifications from 'views/admin/main/others/notifications';
import OthersPricing from 'views/admin/main/others/pricing';
import OthersError from 'views/admin/main/others/404';
import Messages from 'views/admin/main/others/messages';

// Auth Imports
import ForgotPasswordCentered from 'views/auth/forgotPassword/ForgotPasswordCentered';
import ForgotPasswordDefault from 'views/auth/forgotPassword/ForgotPasswordDefault';
import LockCentered from 'views/auth/lock/LockCentered';
import LockDefault from 'views/auth/lock/LockDefault';
import SignInCentered from 'views/auth/signIn/SignInCentered';
import SignInDefault from 'views/auth/signIn/SignInDefault';
import SignUpCentered from 'views/auth/signUp/SignUpCentered';
import SignUpDefault from 'views/auth/signUp/SignUpDefault';
import VerificationCentered from 'views/auth/verification/VerificationCentered';
import VerificationDefault from 'views/auth/verification/VerificationDefault';
/////// OBS

import ListaLocales from 'views/admin/main/ecommerce/Locales';
import ListaUsuarios from 'views/admin/main/ecommerce/Usuarios';

import NuevoLocal from 'views/admin/main/ecommerce/NuevoLocal';
import NuevoUsuario from 'views/admin/main/ecommerce/NuevoUsuario';


// VISITANTES

import NuevoVotante from 'views/admin/main/ERP/Votantes/NuevoVotante';
import RegistrosVotantes from 'views/admin/main/ERP/Votantes/RegistrosVotantes';

//  CANDIDATO 
import NuevoCandidato from 'views/admin/main/ERP/Candidatos/NuevoCandidato';
import RegistroCandidato from 'views/admin/main/ERP/Candidatos/RegistroCandidato';

//  CANDIDATO 
import NuevaEncuesta from 'views/admin/main/ERP/Candidatos/NuevaEncuesta';
import RegistroEncuesta from 'views/admin/main/ERP/Candidatos/RegistroEncuesta';

import Encuestas from 'views/admin/main/ERP/Candidatos/Encuestas';

//  Administradores 
import NuevoAdmin from 'views/admin/main/ERP/Usuarios/NuevoAdmin';
import RegistroAdmin from 'views/admin/main/ERP/Usuarios/RegistroAdmin';


//personal
import NuevoPersonal from 'views/admin/main/ERP/Personal/NuevoPersonal';
import RegistroPersonal from 'views/admin/main/ERP/Personal/RegistroPersonal';




// CLIENTES

import NuevoCliente from 'views/admin/main/ERP/Clientes/NuevoCliente';
import RegistrosCliente from 'views/admin/main/ERP/Clientes/RegistrosCliente';



// PROVEEDOR

import NuevoProveedor from 'views/admin/main/ERP/Proveedores/NuevoProveedor';
import RegistroProveedor from 'views/admin/main/ERP/Proveedores/RegistroProveedores';

// COMPRAS

import NuevaCompra from 'views/admin/main/ERP/Compras/NuevaCompra';
import RegistrosCompras from 'views/admin/main/ERP/Compras/RegistrosCompras';


// VENTAS
import NuevaVenta from 'views/admin/main/ERP/Ventas/NuevaVenta';
import RegistrosVentas from 'views/admin/main/ERP/Ventas/RegistrosVentas';
//INGRESOS 

import NuevoIngreso from 'views/admin/main/ERP/Ingresos/NuevoIngreso';
import RegistrosIngresos from 'views/admin/main/ERP/Ingresos/RegistrosIngresos';

// AGENDA DE ACTIVIDADES


import NuevaActividad from 'views/admin/main/ERP/AgendaActividades/NuevaActividad';
import RegistroActividades from 'views/admin/main/ERP/AgendaActividades/RegistroActividades';
import Album from 'views/admin/main/ERP/AgendaActividades/Album';

// Configuracion 

import AjustePositivo from 'views/admin/main/ERP/Configuracion/AjustePositivo';
import AjusteNegativo from 'views/admin/main/ERP/Configuracion/AjusteNegativo';
import CargaInicial from 'views/admin/main/ERP/Configuracion/CargaInicial';
import Notificaciones from 'views/admin/main/ERP/Configuracion/Notificaciones';

//Supervisores
import NuevoSuper from 'views/admin/main/ERP/Supervisores/NuevoPersonal';
import RegistroSuper from 'views/admin/main/ERP/Supervisores/RegistroPersonal';

//import RegistrosIngresos from 'views/admin/main/ERP/Ingresos/RegistrosIngresos';

//AYUNTAMIENTO PROVISIONAL

import PlanDeTrabajoPresidencia from 'views/PlanDeTrabajoPresidencia'
import AgendaPresidencia from 'views/AgendaPresidencia'
import AtencionCiudadanaPresidencia from 'views/AtencionCiudadanaPresidencia'
import InformeDeActividadesPresidencia from 'views/InformeDeActividadesPresidencia'
import GestionJuridicaLegalSindico from 'views/GestionJuridicaLegalSindico';
import Login from 'views/Login';
import GestionContratacionesLicitacionesSindico from 'views/GestionContratacionesLicitacionesSindico';
import TransparenciaRendicionCuentasSindico from 'views/TransparenciaRendicionCuentasSindico';
import GestionDocumentacionLegalSindico from 'views/GestionDocumentacionLegalSindico';
import GestionDocumentosCorrespondenciaSecretarioGeneral from 'views/GestionDocumentosCorrespondenciaSecretarioGeneral';
import ActasMinutasSecretarioGeneral from 'views/ActasMinutasSecretarioGeneral.tsx';
import AtencionGestionSolicitudesCiudadanasSecretarioGeneral from 'views/AtencionGestionSolicitudesCiudadanasSecretarioGeneral';
import ControlDocumentacionLegalAdministrativaSecretarioGeneral from 'views/ControlDocumentacionLegalAdministrativaSecretarioGeneral';
import PlanificacionSeguimientoProyectosSecretarioGeneral from 'views/PlanificacionSeguimientoProyectosSecretarioGeneral';
import SeguridadControlAccesoSecretarioGeneral from 'views/SeguridadControlAccesoSecretarioGeneral';
import GestionRecursosHumanosSecretarioGeneral from 'views/GestionRecursosHumanosSecretarioGeneral';
import AuditoriaInternaContraloria from 'views/AuditoriaInternaContraloria';
import ControlFinanzasPresupuestoContraloria from 'views/ControlFinanzasPresupuestoContraloria';
import CumplimientoNormativoContraloria from 'views/CumplimientoNormativoContraloria';
import GestionContratacionesLicitacionesContraloria from 'views/GestionContratacionesLicitacionesContraloria';
import AtencionQuejasDenunciasContraloria from 'views/AtencionQuejasDenunciasContraloria';
import ControlProcedimientosAdministrativosContraloria from 'views/ControlProcedimientosAdministrativosContraloria';
import GestionDocumentacionRegistrosContraloria from 'views/GestionDocumentacionRegistrosContraloria';
import { IoMdGlobe } from 'react-icons/io';
import ContabilidadTesoreria from 'views/ContabilidadTesoreria';
import PredialTesoreriaVirtualized from 'views/Predio/PredialTesoreriaVirtualized';
import { FaBalanceScale, FaFaucet, FaFileInvoice, FaMap, FaMapPin, FaMoneyBillWave, FaPiggyBank, FaTape, FaTimes, FaUserAstronaut, FaWater, FaWineBottle } from 'react-icons/fa';
import { FiClipboard, FiUsers, FiFileText, FiEye, FiFile, FiInbox, FiUserCheck, FiBarChart2, FiShield, FiDollarSign, FiCheckCircle, FiAlertCircle, FiPieChart, FiTrendingUp, FiBriefcase, FiPackage, FiWifi, FiBookOpen } from 'react-icons/fi';
import Catalogos from 'views/Catalogos/CatalogosIndex';

import {
  MdEngineering,
  MdLocationCity,
  MdOutlineFence,
  MdOutlineAnnouncement,
  MdHomeWork,
  MdOutlineConstruction,
  MdOutlineAssignment,
  MdGroups,
  MdBlock,
  MdGavel,
  MdSecurity,
  MdAssessment
} from 'react-icons/md';

import Transacciones from 'views/TransaccionesX/Transacciones';
import TransaccionesCajaGral from 'views/CajaGeneral/TransaccionesCajaGral';
import TarifaServiciosCatalogo from 'views/Tarifas/TarifasIndex';
import CajaAguaPotable from 'views/AguaPotable/CajaAguaPotable';
import CFacturados from 'views/CFacturados/CFacturados';

import PropietarioTesoreria from 'views/PropietariosTesoreria';
import PadronCiudadano from 'views/PadronCiudadano';
import UsuarioManagement from 'views/Usuarios/UsuarioIndex';
import TurnosIndex from 'views/Turnos/TurnosIndex';
import { BsBank } from 'react-icons/bs';
import PortalLogin from 'views/PortalCiudadano/PortalLogin';
//============================================

import ObrasUrbanizacion from 'views/ObrasPublicas/ObrasUrbanizacion';
import ObrasFraccionamiento from 'views/ObrasPublicas/ObrasFraccionamiento';
import ObrasDivisionTerrenos from 'views/ObrasPublicas/ObrasDivisionTerrenos';
import ObrasAnuncio from 'views/ObrasPublicas/ObrasAnuncio';
import ObrasPanteon from 'views/ObrasPublicas/ObrasPanteon';
import ObrasConstruccionBase from 'views/ObrasPublicas/ObrasConstruccionBase';
import ObrasDemolicion from 'views/ObrasPublicas/ObrasDemolicion';
import ObrasConstancia from 'views/ObrasPublicas/ObrasConstancia';
import ObrasRegistroContratista from 'views/ObrasPublicas/ObrasRegistroContratista';
import ObrasObstruccionTemporal from 'views/ObrasPublicas/ObrasObstruccionTemporal';
import ObrasMultaObstruccion from 'views/ObrasPublicas/ObrasMultaObstruccion';
import GestionTramites from 'views/ObrasPublicas/GestionTramites';
import GestionTramitesOP from 'views/ObrasPublicas/GestionTramites/GestionTramitesOP';
import DashboardObrasPublicas from 'views/ObrasPublicas/Dashboard/DashboardObrasPublicas';
import  Inicio  from 'views/Inicio/index';
import ObrasPublicasNavigation from 'views/ObrasPublicas/Menu/Navi';
import OficialiaIndex from 'views/Oficialia/OficialiaIndex';

////// DICTAMENES

import TablaDictamenes from 'views/Dictamenes/TablaDictamenes';
import TablaCausas from 'views/JuezMunicipal/TablaCausas';
import TablaDetenciones from 'views/JuezMunicipal/TablaDetenciones';
import TablaInfraccionesPendientes from 'views/JuezMunicipal/TablaInfraccionesPendientes';
import TablaAudiencias from 'views/JuezMunicipal/TablaAudiencias';
import CajaJuzgado from 'views/JuezMunicipal/CajaJuzgado';
import TablaLicencias from 'views/PortalCiudadano/TablaLicenciasConDashboard';
import TablaLicenciasFinanzasEstado from 'views/PortalCiudadano/LicenciasComerciales/TablaLicenciasFinanzasEstado';
import TablaLicenciasResiduos from 'views/PortalCiudadano/LicenciasComerciales/TablaLicenciasResiduos';
import LicenciasVinosLicoresIndex from 'views/PortalCiudadano/LicenciasVinosLicores';
import TablaBitacoras from 'views/BitacoraPC/TablaBitacoras';
import TablaOficialia from 'views/ObrasPublicas/Oficilia/TablaOficialia';
import TablaOpenpayWebhooks from 'views/Transacciones_Online/TablaOpenpayWebhooks';
import MultasPolicia from 'views/PoliciaMunicipal/MultasPolicia';
import MultasJuez from 'views/JuezMunicipal/MultasJuez';
import InfraccionesTransitoVirtualized from 'views/SeguridadPublica/InfraccionesTransitoVirtualized';
import EstadisticasInfracciones from 'views/SeguridadPublica/EstadisticasInfracciones';
// CULTURA
import PlaneacionCultural from 'views/Cultura/PlaneacionCultural';
import ProgramasCulturales from 'views/Cultura/ProgramasCulturales';
import EventosCulturales from 'views/Cultura/EventosCulturales';
import TalleresCulturales from 'views/Cultura/TalleresCulturales';
import PromotoresCulturales from 'views/Cultura/PromotoresCulturales';
import ArtistasColaboradores from 'views/Cultura/ArtistasColaboradores';
import DashboardCultura from 'views/Cultura/DashboardCultura';
// TURISMO
import PlaneacionTuristica from 'views/Turismo/PlaneacionTuristica';
import ProgramasTuristicos from 'views/Turismo/ProgramasTuristicos';
import Atractivos from 'views/Turismo/Atractivos';
import Artesanos from 'views/Turismo/Artesanos';
import PanFiesta from 'views/Turismo/PanFiesta';
import ProductosTurismo from 'views/Turismo/Productos';
import EventosTurismo from 'views/Turismo/Eventos';
import RutasTurismo from 'views/Turismo/Rutas';
import ApoyosTurismo from 'views/Turismo/Apoyos';
import CapacitacionesTurismo from 'views/Turismo/Capacitaciones';
import DashboardTurismo from 'views/Turismo/Dashboard';
// DESARROLLO SOCIAL
import BeneficiariosDS from 'views/DesarrolloSocial/Beneficiarios';
import ProgramasDS from 'views/DesarrolloSocial/Programas';
import ApoyosDS from 'views/DesarrolloSocial/Apoyos';
import ReportesDS from 'views/DesarrolloSocial/Reportes';
import DashboardDS from 'views/DesarrolloSocial/Dashboard';
import MovimientosDS from 'views/DesarrolloSocial/Movimientos';

// ── MÓDULOS 2026: iconos ──
import {
  MdLocalShipping, MdHandyman, MdBuild, MdLightbulb, MdLocalCarWash, MdCelebration,
  MdMenuBook, MdCleaningServices, MdSportsSoccer, MdEmojiEvents, MdPerson, MdCampaign,
  MdInventory2, MdCategory, MdWoman, MdFolderShared, MdSupportAgent, MdReportProblem,
  MdForwardToInbox, MdStorage, MdMoveToInbox, MdPsychology, MdCalendarMonth, MdDescription,
} from 'react-icons/md';

// ── MÓDULOS 2026: Servicios Municipales ──
import ServiciosDashboard from 'views/ServiciosMunicipales/Dashboard';
import ServiciosRecoleccion from 'views/ServiciosMunicipales/Recoleccion';
import ServiciosFaenas from 'views/ServiciosMunicipales/Faenas';
import ServiciosHerramientas from 'views/ServiciosMunicipales/Herramientas';
import ServiciosAlumbrado from 'views/ServiciosMunicipales/Alumbrado';
import ServiciosPanteones from 'views/ServiciosMunicipales/Panteones';
import ServiciosLimpiezaCamiones from 'views/ServiciosMunicipales/LimpiezaCamiones';
import ServiciosDecoracion from 'views/ServiciosMunicipales/Decoracion';
import ServiciosBitacora from 'views/ServiciosMunicipales/Bitacora';
// ── MÓDULOS 2026: Deportes ──
import DashboardDeportes from 'views/Deportes/Dashboard';
import TorneosDeportes from 'views/Deportes/Torneos';
import DeportistasDeportes from 'views/Deportes/Deportistas';
import ConvocatoriasDeportes from 'views/Deportes/Convocatorias';
import InventarioDeportes from 'views/Deportes/Inventario';
import CatalogosDeportes from 'views/Deportes/Catalogos';
// ── MÓDULOS 2026: Instancia Municipal de la Mujer (IMM) ──
import IMMDashboard from 'views/IMM/Dashboard';
import IMMExpedientes from 'views/IMM/Expedientes';
import IMMAtenciones from 'views/IMM/Atenciones';
import IMMCasos from 'views/IMM/Casos';
import IMMCanalizaciones from 'views/IMM/Canalizaciones';
import IMMBanavim from 'views/IMM/Banavim';
import IMMOrdenes from 'views/IMM/Ordenes';
import IMMDecisiones from 'views/IMM/Decisiones';
import IMMSolicitudes from 'views/IMM/Solicitudes';
import IMMPsicologia from 'views/IMM/Psicologia';
import IMMTalleres from 'views/IMM/Talleres';
import IMMAgenda from 'views/IMM/Agenda';
import IMMConstancias from 'views/IMM/Constancias';
const routes = [
  {
    name: 'H. Ayuntamiento',
    path: '/Ayuntamiento',
    icon: <Icon as={MdWork} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Inicio',
        layout: '/admin',
        perfil: 'admin',
        path: '/index',
        icon: <Icon as={MdHouse} width="20px" height="20px" color="inherit" />,
        component: <Inicio />,
      },
      {
        name: 'Oficialía',
        layout: '/admin',
        perfil: 'admin',
        path: '/oficialia',
        icon: <Icon as={MdDocumentScanner} width="20px" height="20px" color="inherit" />,
        component: <OficialiaIndex />,
      },
    ]},
    {
      name: 'Obras Públicas',
      path: '/obras-index',
      icon: <Icon as={MdEngineering} width="20px" height="20px" color="inherit" />,
      collapse: true,
      items: [
        {
          name: 'Menu',
          layout: '/admin',
          perfil: 'admin',
          path: '/obras-menu',
          icon: <Icon as={MdLocationCity} width="20px" height="20px" color="inherit" />,
          component: <ObrasPublicasNavigation />,
        },
          {
          name: 'Gestión de Trámites',
          layout: '/admin',
          perfil: 'admin',
          path: '/gestion-tramites',
          icon: <Icon as={MdEditDocument} width="20px" height="20px" color="inherit" />,
          component: <GestionTramites />,
        },
        {
          name: 'Gestión Integral OP',
          layout: '/admin',
          perfil: 'admin',
          path: '/gestion-tramites-op',
          icon: <Icon as={MdEditDocument} width="20px" height="20px" color="inherit" />,
          component: <GestionTramitesOP />,
        },
        {
          name: 'Dashboard OP',
          layout: '/admin',
          perfil: 'admin',
          path: '/obras-dashboard',
          icon: <Icon as={MdEditDocument} width="20px" height="20px" color="inherit" />,
          component: <DashboardObrasPublicas />,
        },
          {
          name: 'Oficialia',
          layout: '/admin',
          perfil: 'admin',
          path: '/obras-oficialia',
          icon: <Icon as={MdDocumentScanner} width="20px" height="20px" color="inherit" />,
          component: <TablaOficialia />,
        }
      ]}
        ,

          {
    name: 'Juzgado Municipal',
    path: '/Juez',
    icon: <Icon as={MdGavel} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Detenciones',
        layout: '/admin',
        perfil: 'admin',
        path: '/juzgado/detenciones',
        icon: <Icon as={MdSecurity} width="20px" height="20px" color="inherit" />,
        component: <TablaDetenciones />,
      },
      {
        name: 'Infracciones / Calificar',
        layout: '/admin',
        perfil: 'admin',
        path: '/juzgado/infracciones',
        icon: <Icon as={MdGavel} width="20px" height="20px" color="inherit" />,
        component: <TablaInfraccionesPendientes />,
      },
      {
        name: 'Audiencias',
        layout: '/admin',
        perfil: 'admin',
        path: '/juzgado/audiencias',
        icon: <Icon as={MdAssessment} width="20px" height="20px" color="inherit" />,
        component: <TablaAudiencias />,
      },
      {
        name: 'Registro de Remisiones',
        layout: '/admin',
        perfil: 'admin',
        path: '/causas',
        icon: <Icon as={MdLocationCity} width="20px" height="20px" color="inherit" />,
        component: <TablaCausas />,
      },
      {
        name: 'Multas (Juez)',
        layout: '/admin',
        perfil: 'admin',
        path: '/juez/multas',
        icon: <Icon as={MdGavel} width="20px" height="20px" color="inherit" />,
        component: <MultasJuez />,
      },
      {
        name: 'Caja — Pago Sanciones',
        layout: '/admin',
        perfil: 'admin',
        path: '/juzgado/caja',
        icon: <Icon as={MdMoney} width="20px" height="20px" color="inherit" />,
        component: <CajaJuzgado />,
      },
    ]
    },

       {
    name: 'Proteccion Civil',
    path: '/ProteccionCivil',
    icon: <Icon as={MdRule} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
        {
        name: 'Dictamen',
        layout: '/admin',
        perfil: 'admin',
        path: '/dictamenes',
        icon: <Icon as={MdPausePresentation} width="20px" height="20px" color="inherit" />,
        component: <TablaDictamenes />,
      },

         {
        name: 'Bitácora',
        layout: '/admin',
        perfil: 'admin',
        path: '/bitacoras',
        icon: <Icon as={MdPausePresentation} width="20px" height="20px" color="inherit" />,
        component: <TablaBitacoras />,
      },
    ]
    },



    {
    name: 'Seguridad Pública',
    path: '/seguridad-publica',
    icon: <Icon as={MdSecurity} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Infracciones de Tránsito',
        layout: '/admin',
        perfil: 'admin',
        path: '/seguridad-publica/infracciones',
        icon: <Icon as={MdGavel} width="20px" height="20px" color="inherit" />,
        component: <InfraccionesTransitoVirtualized />,
      },
      {
        name: 'Estadísticas',
        layout: '/admin',
        perfil: 'admin',
        path: '/seguridad-publica/estadisticas',
        icon: <Icon as={MdAssessment} width="20px" height="20px" color="inherit" />,
        component: <EstadisticasInfracciones />,
      },
    ]
    },

    {
    name: 'Desarrollo Eco.',
    path: '/tramites',
    icon: <Icon as={MdArchive} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
   
      {
        name: 'Licencias Comerciales',
        layout: '/admin',
        perfil: 'admin',
        path: '/comerciales',
        icon: <Icon as={MdWork} width="20px" height="20px" color="inherit" />,
        component: <PortalLogin />,
      },
      {
        name: 'Licencias Vinos y Licores',
        layout: '/admin',
        perfil: 'admin',
        path: '/vinos-licores',
        icon: <Icon as={FaWineBottle} width="20px" height="20px" color="inherit" />,
        component: <LicenciasVinosLicoresIndex />,
      },
      // {
      //   name: 'Licencias del Estado',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/licencias-estado',
      //   icon: <Icon as={MdWork} width="20px" height="20px" color="inherit" />,
      //   component: <TablaLicenciasFinanzasEstado />,
      // },
      // {
      //   name: 'Residuos Materiales',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/residuos-materiales',
      //   icon: <Icon as={MdWork} width="20px" height="20px" color="inherit" />,
      //   component: <TablaLicenciasResiduos />,
      // },
    ]
    }
  // {
  //   name: 'Obras Públicas - Rutas',
  //   path: '/obras-publicas',
  //   icon: <Icon as={MdEngineering} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //      {
  //       name: 'Causas Juez',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/causas',
  //       icon: <Icon as={MdLocationCity} width="20px" height="20px" color="inherit" />,
  //       component: <TablaCausas />,
  //     },
  //          {
  //       name: 'Dictamen',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/dictamenes',
  //       icon: <Icon as={MdLocationCity} width="20px" height="20px" color="inherit" />,
  //       component: <TablaDictamenes />,
  //     },
  //     {
  //       name: 'Menu',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/urbanizacion-menu',
  //       icon: <Icon as={MdLocationCity} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasPublicasNavigation />,
  //     },
  //     {
  //       name: 'Urbanización',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/urbanizacion',
  //       icon: <Icon as={MdLocationCity} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasUrbanizacion />,
  //     },
  //     {
  //       name: 'Fraccionamiento',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/fraccionamiento',
  //       icon: <Icon as={MdOutlineFence} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasFraccionamiento />,
  //     },
  //     {
  //       name: 'División de Terrenos',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/division-terrenos',
  //       icon: <Icon as={MdOutlineFence} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasDivisionTerrenos />,
  //     },
  //     {
  //       name: 'Anuncios Espectaculares',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/anuncios',
  //       icon: <Icon as={MdOutlineAnnouncement} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasAnuncio />,
  //     },
  //     {
  //       name: 'Panteones',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/panteones',
  //       icon: <Icon as={MdOutlineContactEmergency} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasPanteon />,
  //     },
  //     {
  //       name: 'Construcción de Bases',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/construccion-base',
  //       icon: <Icon as={MdHomeWork} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasConstruccionBase />,
  //     },
  //     {
  //       name: 'Demoliciones',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/demoliciones',
  //       icon: <Icon as={MdOutlineConstruction} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasDemolicion />,
  //     },
  //     {
  //       name: 'Constancias',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/constancias',
  //       icon: <Icon as={MdOutlineAssignment} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasConstancia />,
  //     },
  //     {
  //       name: 'Contratistas',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/contratistas',
  //       icon: <Icon as={MdGroups} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasRegistroContratista />,
  //     },
  //     {
  //       name: 'PENDIENTE: Obstrucción Temporal',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/obstruccion-temporal',
  //       icon: <Icon as={MdBlock} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasObstruccionTemporal />,
  //     },
  //     {
  //       name: 'Multa por Obstrucción',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/multas-obstruccion',
  //       icon: <Icon as={MdGavel} width="20px" height="20px" color="inherit" />,
  //       component: <ObrasMultaObstruccion />,
  //     },
  //   ],
  // }
  ,
  // {
  //   name: 'Mis Tramites',
  //   path: '/tramites',
  //   icon: <Icon as={IoMdGlobe} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
   
  //     {
  //       name: 'Licencias',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/comerciales',
  //       icon: <Icon as={MdWork} width="20px" height="20px" color="inherit" />,
  //       component: <PortalLogin />,
  //     },

  //     {
  //       name: 'Predios',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/predios',
  //       icon: <Icon as={MdAddHomeWork} width="20px" height="20px" color="inherit" />,
  //       component: <PortalLogin />,
  //     },

  //     {
  //       name: 'Agua Potable',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/agua-potable',
  //       icon: <Icon as={MdWash} width="20px" height="20px" color="inherit" />,
  //       component: <PortalLogin />,
  //     },
  //     {
  //       name: 'Solicitudes',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/agua-potable',
  //       icon: <Icon as={MdNewspaper} width="20px" height="20px" color="inherit" />,
  //       component: <PortalLogin />,
  //     },

      // {
      //   name: 'Multas',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/multas',
      //   icon: <Icon as={MdCalculate} width="20px" height="20px" color="inherit" />,
      //   component: <PortalLogin />,
      // },
      // {
      //   name: 'Obras Publicas',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/obras-publicas',
      //   icon: <Icon as={MdCalculate} width="20px" height="20px" color="inherit" />,
      //   component: <PortalLogin />,
      // },
    
    // ],
  // },
  // {
  //   name: 'Presidencia',
  //   path: '/Presidencia',
  //   icon: <Icon as={IoMdGlobe} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
   
  //     {
  //       name: 'Plan de trabajo',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/plan-de-trabajo',
  //       icon: <Icon as={MdEditDocument} width="20px" height="20px" color="inherit" />,
  //       component: <PlanDeTrabajoPresidencia />,
  //     },
      // {
      //   name: 'Agenda',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/agenda',
      //   icon: <Icon as={MdViewAgenda} width="20px" height="20px" color="inherit" />,
      //   component: <AgendaPresidencia />,
      // },
      // {
      //   name: 'Informe de Actividades',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/informe-de-actividades',
      //   icon: <Icon as={FiClipboard} width="20px" height="20px" color="inherit" />,
      //   component: <InformeDeActividadesPresidencia />,
      // },
      // {
      //   name: 'Atención ciudadana',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/atencion-ciudadana',
      //   icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
      //   component: <AtencionCiudadanaPresidencia />,
      // },
    // ],
  // },
  // {
  //   name: 'Inicio de Sesion',
  //   path: '/login',
  //   icon: <Icon as={MdLogin} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Inicio de Sesion',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/login',
  //       icon: <Icon as={FaBalanceScale} width="20px" height="20px" color="inherit" />,
  //       component: <Login />,
  //     },
  //   ]
  // },
  // {
  //   name: 'Sindico',
  //   path: '/Sindico',
  //   icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Gestión jurídica y legal',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-juridica-legal',
  //       icon: <Icon as={FaBalanceScale} width="20px" height="20px" color="inherit" />,
  //       component: <GestionJuridicaLegalSindico />,
  //     },
  //     {
  //       name: 'Gestión de Contrataciones y Licitaciones',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-contrataciones-licitaciones',
  //       icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
  //       component: <GestionContratacionesLicitacionesSindico />,
  //     },
  //     {
  //       name: 'Transparencia y Rendición de Cuentas',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/transparencia-rendicion-cuentas',
  //       icon: <Icon as={FiEye} width="20px" height="20px" color="inherit" />,
  //       component: <TransparenciaRendicionCuentasSindico />,
  //     },
  //     {
  //       name: 'Gestión de Documentación Legal',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-documentacion-legal',
  //       icon: <Icon as={FiFile} width="20px" height="20px" color="inherit" />,
  //       component: <GestionDocumentacionLegalSindico />,
  //     },
  //   ],
  // },
  // {
  //   name: 'Secretario General',
  //   path: '/SecreGeneral',
  //   icon: <Icon as={MdDirections} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Gestión de Documentos y Correspondencia',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       secondary: true,
  //       path: '/gestion-documentos-correspondencia',
  //       icon: <Icon as={FiInbox} width="20px" height="20px" color="inherit" />,
  //       component: <GestionDocumentosCorrespondenciaSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Actas y Minutas',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/actas-minutas',
  //       icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
  //       component: <ActasMinutasSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Gestión de Recursos Humanos',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-recursos-humanos',
  //       icon: <Icon as={FiUserCheck} width="20px" height="20px" color="inherit" />,
  //       component: <GestionRecursosHumanosSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Control de Documentación Legal y Administrativa',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/control-documentacion-legal-administrativa',
  //       icon: <Icon as={FiFile} width="20px" height="20px" color="inherit" />,
  //       component: <ControlDocumentacionLegalAdministrativaSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Planificación y Seguimiento de Proyectos',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/planificacion-seguimiento-proyectos',
  //       icon: <Icon as={FiBarChart2} width="20px" height="20px" color="inherit" />,
  //       component: <PlanificacionSeguimientoProyectosSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Atención y Gestión de Solicitudes Ciudadanas',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/atencion-gestion-solicitudes-ciudadanas',
  //       icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
  //       component: <AtencionGestionSolicitudesCiudadanasSecretarioGeneral />,
  //     },
  //     {
  //       name: 'Seguridad y Control de Acceso',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/seguridad-control-acceso',
  //       icon: <Icon as={FiShield} width="20px" height="20px" color="inherit" />,
  //       component: <SeguridadControlAccesoSecretarioGeneral />,
  //     },
  //   ],
  // },
  // {
  //   name: 'Contraloria',
  //   path: '/Contraloria',
  //   icon: <Icon as={MdCalculate} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Auditoría Interna Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/auditoria-interna',
  //       icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
  //       component: <AuditoriaInternaContraloria />,
  //     },
  //     {
  //       name: 'Control de Finanzas y Presupuesto Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/control-finanzas-presupuesto',
  //       icon: <Icon as={FiDollarSign} width="20px" height="20px" color="inherit" />,
  //       component: <ControlFinanzasPresupuestoContraloria />,
  //     },
  //     {
  //       name: 'Gestión de Contrataciones y Licitaciones Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-contrataciones-licitaciones',
  //       icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
  //       component: <GestionContratacionesLicitacionesContraloria />,
  //     },
  //     {
  //       name: 'Cumplimiento Normativo Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/cumplimiento-normativo',
  //       icon: <Icon as={FiCheckCircle} width="20px" height="20px" color="inherit" />,
  //       component: <CumplimientoNormativoContraloria />,
  //     },
  //     {
  //       name: 'Atención de Quejas y Denuncias Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/atencion-quejas-denuncias',
  //       icon: <Icon as={FiAlertCircle} width="20px" height="20px" color="inherit" />,
  //       component: <AtencionQuejasDenunciasContraloria />,
  //     },
  //     {
  //       name: 'Control de Procedimientos Administrativos Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/control-procedimientos-administrativos',
  //       icon: <Icon as={FiClipboard} width="20px" height="20px" color="inherit" />,
  //       component: <ControlProcedimientosAdministrativosContraloria />,
  //     },
  //     {
  //       name: 'Gestión de Documentación y Registros Contraloria',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/gestion-documentacion-registros',
  //       icon: <Icon as={FiFile} width="20px" height="20px" color="inherit" />,
  //       component: <GestionDocumentacionRegistrosContraloria />,
  //     },
  //   ],
  // },
  // {
  //   name: 'Catalogos',
  //   path: '/Catalogos',
  //   icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
    
    
  //     {
  //       name: 'Catalogo',
  //       layout: '/admin',
  //       perfil: 'admin',
  //       path: '/Catalogos/catalogo',
  //       icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
  //       component: <Catalogos />,
  //     },]}
      
  //     ,
    
  {
    name: 'Tesoreria',
    path: '/Tesoreria',
    icon: <Icon as={MdMoney} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Propietarios',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/propietarios',
        icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
        component: <PropietarioTesoreria />,
      },
        {
        name: 'Pagos en Linea',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/online-pays',
        icon: <Icon as={FiWifi} width="20px" height="20px" color="inherit" />,
        component: <TablaOpenpayWebhooks />,
      },

      {
        name: 'Padron de Ciudadanos',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/ciudadanos',
        icon: <Icon as={FaUserAstronaut} width="20px" height="20px" color="inherit" />,
        component: <PadronCiudadano />,
      },
      {
        name: 'Predios',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/predios',
        icon: <Icon as={FaMapPin} width="20px" height="20px" color="inherit" />,
        component: <PredialTesoreriaVirtualized />,
      },
      {
        name: 'Transacciones de Caja General',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/transaccionescgeneral',
        icon: <Icon as={FaPiggyBank} width="20px" height="20px" color="inherit" />,
        component: <TransaccionesCajaGral />,
      },
      {
        name: 'Agua Potable',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/AguaPotable',
        icon: <Icon as={FaFaucet} width="20px" height="20px" color="inherit" />,
        component: <CajaAguaPotable />,
      },
      {
        name: 'Conceptos Facturados',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/CFacturados',
        icon: <Icon as={FaFileInvoice} width="20px" height="20px" color="inherit" />,
        component: <CFacturados />,
      },
      {
        name: 'Transacciones de Predio',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/transacciones',
        icon: <Icon as={BsBank} width="20px" height="20px" color="inherit" />,
        component: <Transacciones />,
      },

      {
        name: 'Detalles de Recaudacion',
        layout: '/admin',
        perfil: 'admin',
        path: '/tesoreria/recaudacion',
        icon: <Icon as={FaMoneyBillWave} width="20px" height="20px" color="inherit" />,
        component: <CFacturados />,
      },
     
    //   {
    //     name: 'Tarifas',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/tarifas',
    //     icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
    //     component: <TarifaServiciosCatalogo />,
    //   },
    //   {
    //     name: 'Recursos Humanos',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/recursos-humanos',
    //     icon: <Icon as={FiUserCheck} width="20px" height="20px" color="inherit" />,
    //   //  component: <RecursosHumanosTesoreria />,
    //   },
    //   {
    //     name: 'Reportes y Análisis Financiero',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/reportes-analisis-financiero',
    //     icon: <Icon as={FiBarChart2} width="20px" height="20px" color="inherit" />,
    //  //   component: <ReportesAnalisisFinancieroTesoreria />,
    //   },
    //   {
    //     name: 'Control de Deuda',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/control-deuda',
    //     icon: <Icon as={FiDollarSign} width="20px" height="20px" color="inherit" />,
    //   //  component: <ControlDeudaTesoreria />,
    //   },
    //   {
    //     name: 'Gestión de Inversiones',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/gestion-inversiones',
    //     icon: <Icon as={FiTrendingUp} width="20px" height="20px" color="inherit" />,
    //   //  component: <GestionInversionesTesoreria />,
    //   },
    //   {
    //     name: 'Gestión de Subsidios y Subvenciones',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/gestion-subsidios-subvenciones',
    //     icon: <Icon as={FiBriefcase} width="20px" height="20px" color="inherit" />,
    //  //   component: <GestionSubsidiosSubvencionesTesoreria />,
    //   },
    //   {
    //     name: 'Gestión de Activos Fijos',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/gestion-activos-fijos',
    //     icon: <Icon as={FiPackage} width="20px" height="20px" color="inherit" />,
    //    // component: <GestionActivosFijosTesoreria />,
    //   },
    //   {
    //     name: 'Control de Contratos y Pagos',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/control-contratos-pagos',
    //     icon: <Icon as={FiFileText} width="20px" height="20px" color="inherit" />,
    //  //   component: <ControlContratosPagosTesoreria />,
    //   },
    //   {
    //     name: 'Gestión de Impuestos y Contribuciones',
    //     layout: '/admin',
    //     perfil: 'admin',
    //     path: '/tesoreria/gestion-impuestos-contribuciones',
    //     icon: <Icon as={FiDollarSign} width="20px" height="20px" color="inherit" />,
    //   //  component: <GestionImpuestosContribucionesTesoreria />,
    //   },
    ],
  },
  
  // --- NFTs ---
  // {
  //   name: 'NFTs',
  //   path: '/nfts',
  //   icon: (
  //     <Icon
  //       as={MdOutlineShoppingCart}
  //       width="20px"
  //       height="20px"
  //       color="inherit"
  //     />
  //   ),
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Marketplace',
  //       layout: '/rtl',
  //       path: '/nfts/marketplace',
  //       component: <NFTMarketplace />,
  //       secondary: true,
  //     },
  //   ],
  // },
  // // --- Main pages ---

  // {
  //   name: 'Votos',
  //   path: '/comitiva',
  //   icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Votantes',
  //       path: '/main/ERP/Votantes',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Votos Promovidos',
  //           layout: '/comitiva',
  //           path: '/main/ERP/Votantes/NuevoVotante',
  //           exact: false,
  //           component: <NuevoVotante />,
  //         }, {
  //           name: 'Registro de Votos Promovidos',
  //           layout: '/comitiva',
  //           path: '/main/ERP/Votantes/RegistrosVotantes',
  //           exact: false,
  //           // component: <EcommerceOrderList />,
  //           component: <RegistrosVotantes />,
  //         },
  //       ]
  //     }]
  // },

  // {
  //   name: 'Sistema',
  //   path: '/main',
  //   icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Candidatos',
  //       path: '/main/ERP/Candidatos',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nuevo Candidato',
  //           layout: '/admin',
  //           path: '/main/ERP/Candidatos/NuevoCandidato',
  //           exact: false,
  //           component: <NuevoCandidato />,
  //         }, {
  //           name: 'Registro de Candidatos',
  //           layout: '/admin',
  //           path: '/main/ERP/Candidatos/RegistroCandidato',
  //           exact: false,
  //           component: <RegistroCandidato />,
  //         },
  //         {
  //           name: 'Nueva Encuesta',
  //           layout: '/admin',
  //           path: '/main/ERP/Candidatos/NuevaEncuesta',
  //           exact: false,
  //           component: <NuevaEncuesta />,
  //         }, {
  //           name: 'Registro de Encuestas',
  //           layout: '/admin',
  //           path: '/main/ERP/Candidatos/RegistroEncuesta',
  //           exact: false,
  //           component: <RegistroEncuesta />,
  //         }
        
  //       ]
  //     },
   
  //     {
  //       name: 'Supervisores',
  //       path: '/main/ERP/Personal/NuevoPersonal',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nuevo Supervisor',
  //           layout: '/admin',
  //           path: '/main/ERP/Super/NuevoSuper',
  //           exact: false,
  //           component: <NuevoSuper />,
  //         }, {
  //           name: 'Registro de Supervisor',
  //           layout: '/admin',
  //           path: '/main/ERP/Super/RegistroSuper',
  //           exact: false,
  //           component: <RegistroSuper />,
  //         },
  //       ]
  //     },


  //     {
  //       name: 'Administradores',
  //       path: '/main/ERP/Usuarios/NuevoAdmin',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nuevo Administrador',
  //           layout: '/admin',
  //           path: '/main/ERP/Usuarios/NuevoAdmin',
  //           exact: false,
  //           component: <NuevoAdmin />,
  //         }, {
  //           name: 'Registro de Administradores',
  //           layout: '/admin',
  //           path: '/main/ERP/Usuarios/RegistroAdmin',
  //           exact: false,
  //           component: <RegistroAdmin />,
  //         },
        
  //       ]
  //     },

  //     {
  //       name: 'Mi Personal',
  //       path: '/main/ERP/Personal/NuevoPersonal',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nuevo Personal',
  //           layout: '/admin',
  //           path: '/main/ERP/Personal/NuevoPersonal',
  //           exact: false,
  //           component: <NuevoPersonal />,
  //         }, {
  //           name: 'Registro de Personal',
  //           layout: '/admin',
  //           path: '/main/ERP/Personal/RegistroPersonal',
  //           exact: false,
  //           component: <RegistroPersonal />,
  //         },
  //       ]
  //     },
   
  //     {
  //       name: 'Proveedores',
  //       path: '/main/account',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nuevo Proveedor',
  //           layout: '/admin',
  //           path: '/main/ERP/Proveedor/NuevoProveedor',
  //           exact: false,
  //           component: <NuevoProveedor />,
  //         }, {
  //           name: 'Registro de Proveedores',
  //           layout: '/admin',
  //           path: '/main/ERP/Proveedor/RegistroProveedores',
  //           exact: false,
  //           component: <RegistroProveedor />,
  //         },
  //       ]
  //     },
  //     {
  //       name: 'Compras',
  //       path: '/main/ERP/Compras',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nueva Compra',
  //           layout: '/admin',
  //           path: '/main/ERP/Compras/NuevaCompra',
  //           exact: false,
  //           component: <NuevaCompra />,
  //         }, {
  //           name: 'Registro de Compras',
  //           layout: '/admin',
  //           path: '/main/ERP/Compras/RegistrosCompras',
  //           exact: false,
  //           component: <RegistrosCompras />,
  //         },
  //       ]
  //     },
  //     {
  //       name: 'Ventas',
  //       path: '/main/ERP/Ventas',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nueva Venta',
  //           layout: '/admin',
  //           path: '/main/ERP/Ventas/NuevaVenta',
  //           exact: false,
  //           component: <NuevaVenta />,
  //         }, {
  //           name: 'Registro de Ventas',
  //           layout: '/admin',
  //           path: '/main/ERP/Ventas/RegistrosVentas',
  //           exact: false,
  //           component: <RegistrosVentas />,
  //         },
  //       ]
  //     },
    
  //     {
  //       name: 'Agenda',
  //       path: '/main/ERP/AgendaActividades',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Nueva Actividad',
  //           layout: '/admin',
  //           path: '/main/ERP/AgendaActividades/NuevaActividad',
  //           exact: false,

  //           component: <NuevaActividad />,

  //         }, {
  //           name: 'Registro de Actividades',
  //           layout: '/admin',
  //           path: '/main/ERP/AgendaActividades/RegistroActividades',
  //           exact: false,
  //           component: <RegistroActividades />,
  //         },

  //         {
  //           name: 'Galeria de Evidencias',
  //           layout: '/admin',
  //           path: '/main/ERP/AgendaActividades/Calendario',
  //           exact: false,
  //           component: <Album />,
  //         },
  //       ]
  //     },



  //     {
  //       name: 'Configuracion',
  //       path: '/main/account',
  //       collapse: true,
  //       items: [
        

  //         {
  //           name: 'Carga Inicial',
  //           layout: '/admin',
  //           path: '/main/ERP/Configuracion/CargaInicial',
  //           exact: false,
  //           component: <CargaInicial />,
  //         }, {
  //           name: 'Ajuste Positivo',
  //           layout: '/admin',
  //           path: '/main/ERP/Configuracion/AjustePositivo',
  //           exact: false,

  //           component: <AjustePositivo />,
  //         }, {
  //           name: 'Ajuste Negativo',
  //           layout: '/admin',
  //           path: '/main/ERP/Configuracion/AjusteNegativo',
  //           exact: false,
  //           component: <AjusteNegativo />,
  //         },
  //       ]
  //     },
  //   ],


  // },
  // --- Authentication ---
  // {
  //   name: 'Autentificate',
  //   path: '/auth',
  //   icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Inicia Sesion',
  //       path: '/sign-in',
  //       collapse: true,
  //       items: [
  //         {
  //           name: 'Default',
  //           layout: '/auth',
  //           path: '/sign-in/default',
  //           component: <SignInDefault />,
  //         },
       
  //       ],
  //     },
    
  //   ],
  // },

    {
        
    name: 'Sistema',
    path: '/Sistema',
    icon: <Icon as={MdSettings
  
    } width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
     
      {
        name: 'Usuarios',
        layout: '/admin',
        perfil: 'admin',
        path: '/sistema/usuarios',
        icon: <Icon as={FaUserAstronaut} width="20px" height="20px" color="inherit" />,
        component: <UsuarioManagement />,
      },
      {
        name: 'Turnos',
        layout: '/admin',
        perfil: 'admin',
        path: '/sistema/turnos',
        icon: <Icon as={FaTimes} width="20px" height="20px" color="inherit" />,
        component: <TurnosIndex />,
      },
      // {
      //   name: 'Sesiones Iniciadas',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/sistema/s_iniciadas',
      //   icon: <Icon as={FaUserAstronaut} width="20px" height="20px" color="inherit" />,
      //   component: <UsuarioManagement />,
      // },
      // {
      //   name: 'Registro de Acciones',
      //   layout: '/admin',
      //   perfil: 'admin',
      //   path: '/sistema/r_acciones',
      //   icon: <Icon as={FaUserAstronaut} width="20px" height="20px" color="inherit" />,
      //   component: <UsuarioManagement />,
      // }
    ]
      },

  // ==========================================
  // MÓDULO CULTURA
  // ==========================================
  {
    name: 'Cultura',
    path: '/cultura',
    icon: <Icon as={MdPausePresentation} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Planeación Cultural',
        layout: '/admin',
        perfil: 'admin',
        path: '/cultura/planeacion',
        icon: <Icon as={MdRule} width="20px" height="20px" color="inherit" />,
        component: <PlaneacionCultural />,
      },
      {
        name: 'Programas Culturales',
        layout: '/admin',
        perfil: 'admin',
        path: '/cultura/programas',
        icon: <Icon as={MdViewAgenda} width="20px" height="20px" color="inherit" />,
        component: <ProgramasCulturales />,
      },
      {
        name: 'Eventos Culturales',
        layout: '/admin',
        perfil: 'admin',
        path: '/cultura/eventos',
        icon: <Icon as={MdEditDocument} width="20px" height="20px" color="inherit" />,
        component: <EventosCulturales />,
      },
      {
        name: 'Talleres Culturales',
        layout: '/admin',
        perfil: 'admin',
        path: '/cultura/talleres',
        icon: <Icon as={MdViewAgenda} width="20px" height="20px" color="inherit" />,
        component: <TalleresCulturales />,
      },
      {
        name: 'Promotores Culturales',
        layout: '/admin',
        perfil: 'admin',
        path: '/cultura/promotores',
        icon: <Icon as={MdRule} width="20px" height="20px" color="inherit" />,
        component: <PromotoresCulturales />,
      },
      {
        name: 'Artistas y Colaboradores',
        layout: '/admin',
        perfil: 'admin',
        path: '/cultura/artistas',
        icon: <Icon as={MdRule} width="20px" height="20px" color="inherit" />,
        component: <ArtistasColaboradores />,
      },
      {
        name: 'Dashboard Cultura',
        layout: '/admin',
        perfil: 'admin',
        path: '/cultura/dashboard',
        icon: <Icon as={MdPausePresentation} width="20px" height="20px" color="inherit" />,
        component: <DashboardCultura />,
      },
    ],
  },
  // ==========================================
  // MODULO TURISMO Y FOMENTO ARTESANAL
  // ==========================================
  {
    name: 'Turismo y Fomento',
    path: '/turismo',
    icon: <Icon as={MdDirections} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Dashboard',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/dashboard',
        icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
        component: <DashboardTurismo />,
      },
      {
        name: 'Planeacion Turistica',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/planes',
        icon: <Icon as={MdRule} width="20px" height="20px" color="inherit" />,
        component: <PlaneacionTuristica />,
      },
      {
        name: 'Programas Turisticos',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/programas',
        icon: <Icon as={MdViewAgenda} width="20px" height="20px" color="inherit" />,
        component: <ProgramasTuristicos />,
      },
      {
        name: 'Atractivos',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/atractivos',
        icon: <Icon as={MdMap} width="20px" height="20px" color="inherit" />,
        component: <Atractivos />,
      },
      {
        name: 'Artesanos',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/artesanos',
        icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
        component: <Artesanos />,
      },
      {
        name: 'Pan de Fiesta',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/pan-fiesta',
        icon: <Icon as={MdHomeWork} width="20px" height="20px" color="inherit" />,
        component: <PanFiesta />,
      },
      {
        name: 'Productos',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/productos',
        icon: <Icon as={FiPackage} width="20px" height="20px" color="inherit" />,
        component: <ProductosTurismo />,
      },
      {
        name: 'Eventos',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/eventos',
        icon: <Icon as={MdEditDocument} width="20px" height="20px" color="inherit" />,
        component: <EventosTurismo />,
      },
      {
        name: 'Rutas',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/rutas',
        icon: <Icon as={MdDirections} width="20px" height="20px" color="inherit" />,
        component: <RutasTurismo />,
      },
      {
        name: 'Apoyos',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/apoyos',
        icon: <Icon as={FiCheckCircle} width="20px" height="20px" color="inherit" />,
        component: <ApoyosTurismo />,
      },
      {
        name: 'Capacitaciones',
        layout: '/admin',
        perfil: 'admin',
        path: '/turismo/capacitaciones',
        icon: <Icon as={FiBookOpen} width="20px" height="20px" color="inherit" />,
        component: <CapacitacionesTurismo />,
      },
    ],
  },
  // ==========================================
  // MODULO DESARROLLO SOCIAL
  // ==========================================
  {
    name: 'Desarrollo Social',
    path: '/desarrollo-social',
    icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Dashboard',
        layout: '/admin',
        perfil: 'admin',
        path: '/desarrollo-social/dashboard',
        icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
        component: <DashboardDS />,
      },
      {
        name: 'Beneficiarios',
        layout: '/admin',
        perfil: 'admin',
        path: '/desarrollo-social/beneficiarios',
        icon: <Icon as={FiUsers} width="20px" height="20px" color="inherit" />,
        component: <BeneficiariosDS />,
      },
      {
        name: 'Programas',
        layout: '/admin',
        perfil: 'admin',
        path: '/desarrollo-social/programas',
        icon: <Icon as={MdViewAgenda} width="20px" height="20px" color="inherit" />,
        component: <ProgramasDS />,
      },
      {
        name: 'Apoyos',
        layout: '/admin',
        perfil: 'admin',
        path: '/desarrollo-social/apoyos',
        icon: <Icon as={MdPriceCheck} width="20px" height="20px" color="inherit" />,
        component: <ApoyosDS />,
      },
      {
        name: 'Reportes',
        layout: '/admin',
        perfil: 'admin',
        path: '/desarrollo-social/reportes',
        icon: <Icon as={MdAssessment} width="20px" height="20px" color="inherit" />,
        component: <ReportesDS />,
      },
      {
        name: 'Movimientos',
        layout: '/admin',
        perfil: 'admin',
        path: '/desarrollo-social/movimientos',
        icon: <Icon as={FiClipboard} width="20px" height="20px" color="inherit" />,
        component: <MovimientosDS />,
      },
    ],
  },
  {
    name: 'Servicios Municipales',
    path: '/servicios',
    icon: <Icon as={MdCleaningServices} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      { name: 'Dashboard', layout: '/admin', perfil: 'admin', path: '/servicios/dashboard', icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />, component: <ServiciosDashboard /> },
      { name: 'Recolección de Basura', layout: '/admin', perfil: 'admin', path: '/servicios/recoleccion', icon: <Icon as={MdLocalShipping} width="20px" height="20px" color="inherit" />, component: <ServiciosRecoleccion /> },
      { name: 'Faenas', layout: '/admin', perfil: 'admin', path: '/servicios/faenas', icon: <Icon as={MdHandyman} width="20px" height="20px" color="inherit" />, component: <ServiciosFaenas /> },
      { name: 'Herramientas', layout: '/admin', perfil: 'admin', path: '/servicios/herramientas', icon: <Icon as={MdBuild} width="20px" height="20px" color="inherit" />, component: <ServiciosHerramientas /> },
      { name: 'Alumbrado Público', layout: '/admin', perfil: 'admin', path: '/servicios/alumbrado', icon: <Icon as={MdLightbulb} width="20px" height="20px" color="inherit" />, component: <ServiciosAlumbrado /> },
      { name: 'Panteones', layout: '/admin', perfil: 'admin', path: '/servicios/panteones', icon: <Icon as={MdLocationCity} width="20px" height="20px" color="inherit" />, component: <ServiciosPanteones /> },
      { name: 'Limpieza de Camiones', layout: '/admin', perfil: 'admin', path: '/servicios/limpieza-camiones', icon: <Icon as={MdLocalCarWash} width="20px" height="20px" color="inherit" />, component: <ServiciosLimpiezaCamiones /> },
      { name: 'Decoración de Eventos', layout: '/admin', perfil: 'admin', path: '/servicios/decoracion', icon: <Icon as={MdCelebration} width="20px" height="20px" color="inherit" />, component: <ServiciosDecoracion /> },
      { name: 'Bitácora General', layout: '/admin', perfil: 'admin', path: '/servicios/bitacora', icon: <Icon as={MdMenuBook} width="20px" height="20px" color="inherit" />, component: <ServiciosBitacora /> },
    ],
  },
  {
    name: 'Deportes',
    path: '/deportes',
    icon: <Icon as={MdSportsSoccer} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      { name: 'Dashboard', layout: '/admin', perfil: 'admin', path: '/deportes/dashboard', icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />, component: <DashboardDeportes /> },
      { name: 'Torneos', layout: '/admin', perfil: 'admin', path: '/deportes/torneos', icon: <Icon as={MdEmojiEvents} width="20px" height="20px" color="inherit" />, component: <TorneosDeportes /> },
      { name: 'Deportistas', layout: '/admin', perfil: 'admin', path: '/deportes/deportistas', icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />, component: <DeportistasDeportes /> },
      { name: 'Convocatorias', layout: '/admin', perfil: 'admin', path: '/deportes/convocatorias', icon: <Icon as={MdCampaign} width="20px" height="20px" color="inherit" />, component: <ConvocatoriasDeportes /> },
      { name: 'Inventario', layout: '/admin', perfil: 'admin', path: '/deportes/inventario', icon: <Icon as={MdInventory2} width="20px" height="20px" color="inherit" />, component: <InventarioDeportes /> },
      { name: 'Catálogos', layout: '/admin', perfil: 'admin', path: '/deportes/catalogos', icon: <Icon as={MdCategory} width="20px" height="20px" color="inherit" />, component: <CatalogosDeportes /> },
    ],
  },
  {
    name: 'Instancia de la Mujer',
    path: '/imm',
    icon: <Icon as={MdWoman} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      { name: 'Dashboard', layout: '/admin', perfil: 'admin', path: '/imm/dashboard', icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />, component: <IMMDashboard /> },
      { name: 'Expedientes', layout: '/admin', perfil: 'admin', path: '/imm/expedientes', icon: <Icon as={MdFolderShared} width="20px" height="20px" color="inherit" />, component: <IMMExpedientes /> },
      { name: 'Atenciones', layout: '/admin', perfil: 'admin', path: '/imm/atenciones', icon: <Icon as={MdSupportAgent} width="20px" height="20px" color="inherit" />, component: <IMMAtenciones /> },
      { name: 'Casos de Violencia', layout: '/admin', perfil: 'admin', path: '/imm/casos', icon: <Icon as={MdReportProblem} width="20px" height="20px" color="inherit" />, component: <IMMCasos /> },
      { name: 'Canalizaciones', layout: '/admin', perfil: 'admin', path: '/imm/canalizaciones', icon: <Icon as={MdForwardToInbox} width="20px" height="20px" color="inherit" />, component: <IMMCanalizaciones /> },
      { name: 'BANAVIM', layout: '/admin', perfil: 'admin', path: '/imm/banavim', icon: <Icon as={MdStorage} width="20px" height="20px" color="inherit" />, component: <IMMBanavim /> },
      { name: 'Órdenes de Protección', layout: '/admin', perfil: 'admin', path: '/imm/ordenes', icon: <Icon as={MdGavel} width="20px" height="20px" color="inherit" />, component: <IMMOrdenes /> },
      { name: 'Decisiones', layout: '/admin', perfil: 'admin', path: '/imm/decisiones', icon: <Icon as={MdRule} width="20px" height="20px" color="inherit" />, component: <IMMDecisiones /> },
      { name: 'Solicitudes de Auxilio', layout: '/admin', perfil: 'admin', path: '/imm/solicitudes', icon: <Icon as={MdMoveToInbox} width="20px" height="20px" color="inherit" />, component: <IMMSolicitudes /> },
      { name: 'Atención Psicológica', layout: '/admin', perfil: 'admin', path: '/imm/psicologia', icon: <Icon as={MdPsychology} width="20px" height="20px" color="inherit" />, component: <IMMPsicologia /> },
      { name: 'Talleres y Eventos', layout: '/admin', perfil: 'admin', path: '/imm/talleres', icon: <Icon as={MdGroups} width="20px" height="20px" color="inherit" />, component: <IMMTalleres /> },
      { name: 'Agenda Institucional', layout: '/admin', perfil: 'admin', path: '/imm/agenda', icon: <Icon as={MdCalendarMonth} width="20px" height="20px" color="inherit" />, component: <IMMAgenda /> },
      { name: 'Constancias', layout: '/admin', perfil: 'admin', path: '/imm/constancias', icon: <Icon as={MdDescription} width="20px" height="20px" color="inherit" />, component: <IMMConstancias /> },
    ],
  },
];

export default routes;
